import { Controller as BaseController } from "@hotwired/stimulus"

export class Controller extends BaseController {
  static targets = ["button", "collapseIcon", "expandIcon"]
  static classes = ["collapsed"]
  static values = { collapsed: Boolean }

  STORAGE_KEY = "labcore.sidebar_collapsed"

  connect() {
    // Restore the persisted state before Turbo snapshots the new page.
    this.element.style.transition = "none"
    this.collapsedValue = this._load()
    requestAnimationFrame(() => {
      this.element.style.transition = ""
    })
  }

  toggle() {
    this.collapsedValue = !this.collapsedValue
    this._save(this.collapsedValue)
  }

  collapsedValueChanged(collapsed) {
    this.element.classList.toggle(this.collapsedClass, collapsed)
    this.collapseIconTarget.classList.toggle("hidden", collapsed)
    this.expandIconTarget.classList.toggle("hidden", !collapsed)

    const label = collapsed ? "Expand sidebar" : "Collapse sidebar"
    this.buttonTarget.title = label
    this.buttonTarget.setAttribute("aria-label", label)
  }

  _load() {
    return window.localStorage.getItem(this.STORAGE_KEY) === "true"
  }

  _save(collapsed) {
    window.localStorage.setItem(this.STORAGE_KEY, String(collapsed))
  }
}
